var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM11.2637 7.31641C11.069 7.51107 10.9717 7.74805 10.9717 8.02734C10.9717 8.30664 11.069 8.54574 11.2637 8.74463C11.4626 8.93929 11.7017 9.03662 11.981 9.03662C12.256 9.03662 12.4909 8.93929 12.6855 8.74463C12.8844 8.54574 12.9839 8.30664 12.9839 8.02734C12.9839 7.74805 12.8844 7.51107 12.6855 7.31641C12.4909 7.11751 12.256 7.01807 11.981 7.01807C11.7017 7.01807 11.4626 7.11751 11.2637 7.31641ZM10.8701 15.5176C10.7855 15.5938 10.6289 15.6509 10.4004 15.689V16H13.498V15.689C13.2653 15.6424 13.1066 15.5789 13.022 15.4985C12.9373 15.4181 12.895 15.2362 12.895 14.9526V10.0142H10.4004V10.3315C10.6628 10.3781 10.8384 10.45 10.9272 10.5474C11.0161 10.6405 11.0605 10.8182 11.0605 11.0806V14.9019C11.0605 15.1981 10.9971 15.4033 10.8701 15.5176Z",
    fill: "#B7B7B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcn);
export default __webpack_public_path__ + "static/media/info-icn.7b8eae658b16fc468d4b48ad691d0a04.svg";
export { ForwardRef as ReactComponent };